// src/components/About/WhoWeAre.tsx
import React from 'react';
import {
  FounderWrapper,
  FounderImage,
  FounderBottomText,
  CoreValuesGrid,
  CoreValueItem,
} from './WhoWeAre.styles';
import { SectionContentWrapper, GlassContainer, WhiteCard } from '../About.styles';

const WhoWeAre: React.FC = () => {
  return (
    <GlassContainer>
      <WhiteCard>
        <SectionContentWrapper>
          <h2>Who We Are</h2>
          <p>
            Hope Beyond International is a dedicated non-profit organization passionately committed
            to uplifting those confronting life’s most profound challenges, offering care that
            transcends the physical to embrace emotional, spiritual, and communal well-being.
          </p>
          <p>
            Rooted in our core principle of <em>“Ending Health-Related Suffering through Compassionate Care”</em>,
            we work tirelessly to ensure each person feels seen, supported, and empowered.
          </p>

          {/* Founder Section */}
          <FounderWrapper>
            <FounderImage src="images/founder.JPG" alt="Founder" />
            <div>
              <h4>Founder: Rediet Gebeyehu, MD</h4>
              <p>Hematologist Oncologist | Hospice Palliative Specialist</p>
              <p>
                My journey with Hope Beyond International began as a personal quest to ensure that no one
                feels alone when facing the vulnerability of life-limiting conditions. Inspired by the cancer
                patients I care for, I recognized the essential need for compassionate guidance, dignity, and
                understanding for individuals with serious illnesses and their loved ones.
              </p>
            </div>
          </FounderWrapper>

          {/* Vision Section */}
          <FounderBottomText>
            <p>
              Through Hope Beyond International, I aim to build a legacy of holistic care—where every patient’s
              comfort matters, every family finds solace, and every community gains the knowledge and resources
              to foster resilient, empathetic support networks. My vision is not just to alleviate suffering,
              but to nurture hope and human connection in its purest form.
            </p>
          </FounderBottomText>

          {/* Core Values Section */}
          <CoreValuesGrid>
            <CoreValueItem>
              <h3>Compassion</h3>
              <p>We believe in offering care with empathy and kindness.</p>
            </CoreValueItem>
            <CoreValueItem>
              <h3>Dedication</h3>
              <p>Our team is committed to making a difference in every life we touch.</p>
            </CoreValueItem>
            <CoreValueItem>
              <h3>Innovation</h3>
              <p>We continuously seek better ways to serve and support our community.</p>
            </CoreValueItem>
          </CoreValuesGrid>
        </SectionContentWrapper>
      </WhiteCard>
    </GlassContainer>
  );
};

export default WhoWeAre;
